module.exports = __webpack_public_path__ + "static/media/presentation-play.43ac374f.svg";